import * as React from "react";
const SVGComponent = (props) => (
  <svg
    width={200}
    height={178}
    viewBox="0 0 200 178"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="4e7bb337">
      <g id="6af4703d">
        <g id="7c8da2de">
          <path
            id="e6962b55"
            d="M20.294 142.328C17.5582 148.371 13.5566 153.149 8.32993 156.538C5.63495 158.294 4.3283 161.479 5.02246 164.623C5.71662 167.726 8.20743 170.013 11.3516 170.462C19.6815 171.605 35.933 172.218 50.9187 163.234C53.2871 161.805 54.0629 158.743 52.6337 156.374C51.2046 154.006 48.1421 153.23 45.7738 154.659C36.3822 160.294 26.2148 161.356 18.824 161.111C24.0915 156.374 28.0931 150.372 30.7881 143.145C31.4414 141.389 31.0331 139.388 29.7673 138C16.8232 123.912 10.0041 107.007 10.0041 89C10.0041 45.8395 50.3879 10.7232 100 10.7232C149.612 10.7232 189.996 45.8395 189.996 89C189.996 132.16 149.612 167.277 100 167.277C91.7109 167.277 83.4626 166.297 75.541 164.337C72.8461 163.684 70.1511 165.317 69.4978 168.012C68.8444 170.707 70.4777 173.402 73.1727 174.055C81.8701 176.178 90.8942 177.281 100 177.281C155.165 177.281 200 137.673 200 89C200 40.3271 155.165 0.71907 100 0.71907C44.8346 0.71907 0 40.3271 0 89C0 108.232 7.18661 127.056 20.294 142.328Z"
            fill="#222B63"
          />
          <path
            id="cca7582a"
            d="M100 126.526C113.924 126.526 126.46 119.625 132.707 108.559C134.055 106.15 133.238 103.087 130.829 101.74C128.42 100.392 125.357 101.209 124.01 103.618C119.559 111.458 110.127 116.521 100 116.521C89.7918 116.521 80.6043 111.662 76.0719 103.822C74.6836 101.413 71.6211 100.597 69.2528 101.985C66.8436 103.373 66.027 106.436 67.4153 108.804C73.7444 119.747 86.2393 126.526 100 126.526Z"
            fill="#222B63"
          />
          <path
            id="a8b236c6"
            d="M59.6162 87.4484C60.5553 89 62.1886 89.8575 63.9036 89.8575C64.802 89.8575 65.6594 89.6125 66.4761 89.1225L89.4242 75.2393C91.0167 74.2593 91.9559 72.5035 91.8334 70.666C91.7109 68.7877 90.5676 67.1544 88.8934 66.4194L65.4553 55.9661C62.9236 54.8228 59.9837 55.9661 58.8403 58.4978C57.697 61.0294 58.8403 63.9694 61.372 65.1127L76.0719 71.6868L61.2903 80.5884C58.922 82.0176 58.187 85.08 59.6162 87.4484Z"
            fill="#222B63"
          />
          <path
            id="c0d089bf"
            d="M141.16 58.4978C140.016 55.9661 137.076 54.8636 134.545 55.9661L111.107 66.4194C109.392 67.1952 108.248 68.8285 108.167 70.666C108.044 72.5443 108.983 74.3001 110.576 75.2393L133.524 89.1225C134.341 89.6125 135.239 89.8575 136.096 89.8575C137.771 89.8575 139.445 89 140.384 87.4483C141.813 85.08 141.037 82.0176 138.669 80.5884L123.887 71.6868L138.587 65.1127C141.16 63.9694 142.303 61.0294 141.16 58.4978Z"
            fill="#785AF0"
          />
        </g>
      </g>
    </g>
  </svg>
);
export default SVGComponent;
